import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

export const datadogInit = () => {
  const htmlTag = document.getElementsByTagName('html')[0];
  if (!htmlTag) {
    throw new Error('No html tag found');
  }
  const { clientToken, env, version, userId, userName, userEmail } = htmlTag.dataset;
  if (!clientToken) {
    throw new Error('No clientToken found');
  }
  if (!env) {
    throw new Error('No env found');
  }
  if (!version) {
    throw new Error('No version found');
  }
  const datadogOpts: Pick<RumInitConfiguration, 'clientToken' | 'site' | 'service' | 'env' | 'version'> = {
    clientToken,
    site: 'datadoghq.com',
    service: 'parker-ui',
    env,
    version,
  };
  datadogLogs.init({
    ...datadogOpts,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: 'all',
    forwardReports: 'all',
    sessionSampleRate: 100,
  });
  datadogRum.init({
    ...datadogOpts,
    applicationId: '73dbe3e7-ebb2-4c41-94b2-5e1167a17033',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 25,
    defaultPrivacyLevel: 'mask-user-input',
  });
  if (userId && userName && userEmail) {
    datadogRum.setUser({
      id: userId,
      name: userName,
      email: userEmail,
    });
  }
};
